// API Configuration
export const API_CONFIG = {
  BASE_URL: 'https://sparts.in:8443/api/v1',
  s3BucketUrl:'https://indisparedev.s3.ap-south-1.amazonaws.com/',
  // BASE_URL: 'https://indispare-backend.test/api/v1',
  ENDPOINTS: {
    CATEGORIES: '/indispare-mini/categories',
    PRODUCTS: '/indispare-mini/categories/products-by-ids',
    AUTH: '/indispare-mini/auth',
    CART: '/indispare-mini/cart',
    ADDRESS: '/get-customer-address',
    ADDRESS_CREATE: '/addresses/create', // New endpoint for creating address
    PAYMENT: '/indispare-mini/cart/payment-info',
    ORDERS: '/api/orders',
  },
  TIMEOUT: 30000, // 30 seconds - increased from 10 seconds
  // Base URL for default product images
  DEFAULT_IMAGE_BASE_URL: 'https://sparts.in:8443',
} as const;

// API Error class for better error handling
export class ApiError extends Error {
  constructor(
    message: string,
    public status?: number,
    public data?: any
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
